<template>
  <div class="results" :class="currentView">
    <transition name="slide-small-fade">
      <StemwijzerCta v-if="showStemwijzerCTA" @closeCTA="closeStemwijzerCTA" />
    </transition>

    <transition name="fade" mode="out-in">
      <Component :is="currentView" :key="currentView" :animation="radarAnimation" />
    </transition>

    <ActionButtons :state="currentView" />

    <transition name="slide-vertical" mode="">
      <router-view :key="$route.name" />
    </transition>

    <transition name="fade" mode="">
      <div v-if="partyOverlay" class="overlay" />
    </transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ActionButtons from "@/components/Results/ActionButtons";
import Radar from "@/components/Results/Radar";
import List from "@/components/Results/List";
import StemwijzerCta from "@/components/UI/StemwijzerCta";

export default {
  name: "Results",

  components: {
    ActionButtons,
    Radar,
    List,
    StemwijzerCta,
  },

  data: () => ({
    currentView: "Radar",
    radarAnimation: true,
    showStemwijzerCTA: false,
    timerStemwijzerCTA: null,
  }),

  computed: {
    ...mapState({
      results: (state) => state.results,
      timeoutStemwijzerCTA: (state) => state.config.settings.votematchPopupTimeout
    }),

    partyOverlay() {
      return this.$route.name === "party";
    },
  },

  // validate route, are there any results to display?
  // if not, redirect back to selectTheme view
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.results.length) {
        vm.$router.push({ name: "selectTheme" });
      }
    });
  },

  mounted() {
    this.startStemwijzerCTATimer();
    window._paq.push(["trackEvent", location.host.split(".")[0], "result"]);
  },

  methods: {
    toggleView() {
      this.currentView = this.currentView === "Radar" ? "List" : "Radar";
    },

    skipRadarAnimation() {
      this.radarAnimation = false;
    },

    startStemwijzerCTATimer() {
      if (this.timeoutStemwijzerCTA < 0)
        return;
    
      this.timerStemwijzerCTA = setTimeout(() => {
        this.showStemwijzerCTA = true;
        this.clearStemwijzerCTATimer();
      }, this.timeoutStemwijzerCTA);
    },

    clearStemwijzerCTATimer() {
      clearTimeout(this.timerStemwijzerCTA);
    },

    closeStemwijzerCTA() {
      this.showStemwijzerCTA = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.results {
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 0;

  &.List {
    z-index: 2;
  }

  &.Radar {
    justify-content: flex-end;
  }
}

.overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  z-index: 2;
}
</style>
